/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// CGV cart
 if(document.querySelector('body').classList.contains('template-cart')) {
    var buttonCart = document.querySelector('.Cart__Checkout');
    var buttonCartOverlay = document.querySelector('.cart-button-wrapper .overlay-disabled-button');
    var cartRecap = document.querySelector('.Cart__Recap');
    var checkboxCgv = document.getElementById('cgv');

    if(buttonCart.disabled) {
        buttonCartOverlay.addEventListener('click', function(e) {
            cartRecap.classList.add('with-error');
            cartRecap.classList.remove('cgv-accepted');
        });
    }

    checkboxCgv.addEventListener( 'change', function() {
        if(this.checked) {
            cartRecap.classList.remove('with-error');
            cartRecap.classList.add('cgv-accepted');
        } else {
            cartRecap.classList.add('with-error');
            cartRecap.classList.remove('cgv-accepted');
        }
    });
}

// Target blank link footer
var links = document.querySelectorAll('.Footer__Block--links li a');
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

// Quickbuy
$( document ).ready(function() {
    var productItems = document.querySelectorAll('.ProductItem');
    if(productItems) {
        productItems.forEach(function(item) {
            var productVariants = item.querySelectorAll('.quickbuy__variants li');
            var button = item.querySelector('.js-addtocart');
            var input = item.querySelector('.js-input');
            var buttonShowVariants = item.querySelector('.js-show-variants');
            var quickbuy = item.querySelector('.quickbuy');

            if(buttonShowVariants) {
                buttonShowVariants.addEventListener('click', ()=> {
                    quickbuy.classList.add('variants-visibles');
                });
            }

          productVariants.forEach(function(item) {
            item.addEventListener('click', function() {
                var variantID = item.getAttribute('data-value');
                var variantSku = item.getAttribute('data-sku');

                input.value = variantID;
                input.setAttribute("data-sku", variantSku); 

                addItemToCart( variantID, 1);
                quickbuy.classList.remove('variants-visibles');
                quickbuy.classList.add('item-added');
            });
          });

          if(button != null) {
                button.addEventListener('click', function() {
                    var ID = input.getAttribute('value');

                    addItemToCart( ID, 1);
                    quickbuy.classList.add('item-added');
                });
            }
        });
    }

    function addItemToCart(variant_id, qty) {
        data = {
            "id": variant_id,
            "quantity": qty
        }
        jQuery.ajax({
            type: 'POST',
            url: `${window.SHOPIFY_ROUTES.cart_add_url || '/cart/add'}.js`,
            data: data,
            dataType: 'json',
            success: function() {
                document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                        variant: variant_id,
                        quantity: 1
                    }
                }));

                setTimeout(function() {
                    document.querySelector('.quickbuy.item-added').classList.remove('item-added');
                }, 2000);
                
            }
        });
    }
});